<div class="alert-preferences-container">
  <div kendoDialogContainer></div>
  <div class="filter-controls row align-items-center g-0">
    <div class="col-4 d-flex align-items-center gap-2">
    <div class="tag-filter-container">
      <button
        #tagFilterAnchor
        kendoButton
        [toggleable]="true"
        [(selected)]="showTagFilter"
        class="tag-filter-button cyflare-btn-secondary"
      >
        Filter by tag {{ selectedTags.length ? '(' + selectedTags.length + ')' : '' }}
      </button>

      @if (showTagFilter) {
      <kendo-popup
        [anchor]="tagFilterAnchor"
        [animate]="false"
        (close)="showTagFilter = false"
        [popupClass]="'tag-filter-popup'"
      >
        <kendo-multiselect
          style="width: 400px"
          #detectionTagsRef
          [(ngModel)]="selectedTags"
          [filterable]="true"
          [data]="availableTags()"
          textField="name"
          valueField="id"
          [valuePrimitive]="false"
          (valueChange)="filterDetetections()"
          (filterChange)="onTagFilterChange($event)"
          (remove)="onTagRemove($event)"
          (clear)="onTagClear()"
        ></kendo-multiselect>
      </kendo-popup>
      }
    </div>

    <kendo-label
      class="ms-3 me-1"
      text="Show new only"
      labelCssClass="k-form-label"
    ></kendo-label>
    <kendo-switch
      class="filter-switch"
      [(ngModel)]="showNewOnly"
      (valueChange)="showNewOnlyChange($event)"
    ></kendo-switch>
    </div>

    <div class="col-5 d-flex justify-content-center">
      @if (alertSyncControls().propagate_to_children || alertSyncControls().stop_parent_sync) {
      <div class="sync-settings">
        @if (alertSyncControls().propagate_to_children) {
        <span class="sync-setting">
          Alert Preferences Propagation:
          <strong>{{ propagateEnabled() ? 'Enabled' : 'Disabled' }}</strong>
        </span>
        }
        @if (alertSyncControls().stop_parent_sync) {
        <span class="sync-setting">
          Stop Parent Synchronization:
          <strong>{{ stopParentSyncEnabled() ? 'Enabled' : 'Disabled' }}</strong>
        </span>
        }
      </div>
      }
    </div>

    <div class="col-3 d-flex justify-content-end">
      <!-- Manual propagation: shown for a non-root org with children, independent
           of the propagate toggle state (it can trigger propagation itself). -->
      @if (alertSyncControls().propagate_to_children) {
      <button
        kendoButton
        themeColor="primary"
        [disabled]="isPropagating() || isLoading() || !organizationId()"
        (click)="onPropagateClick()"
      >
        @if (isPropagating()) {
        <span class="spinner-border spinner-border-sm me-2"></span>
        Propagating... } @else { Propagate to child organizations }
      </button>
      }
    </div>
  </div>
  <hr />

  @if (totalRecords === 0) {
  <div class="alert-preferences-empty-state">No detections found</div>
  } @else {
  <div>
    <div
      class="k-card-list"
      (scroll)="onScroll($event)"
    >
      @for (detection of filteredDetections(); track detection.detectionId) {
      <div>
        <kendo-card class="k-card-item">
          <kendo-card-header>
            <div class="card-header-content">
              <h5>{{ detection.title }}</h5>
              @if (detection.isNew) {
              <kendo-chip
                size="small"
                label="New"
              ></kendo-chip>
              }
            </div>
          </kendo-card-header>
          <kendo-card-body>
            <p>{{ detection.description }}</p>
            <p>
              @for (tag of detection.tags; track tag.id) {
              <kendo-chip
                size="small"
                [label]="tag.name"
                class="me-1 mb-1"
              ></kendo-chip>
              }
            </p>
          </kendo-card-body>
          <kendo-card-footer>
            <kendo-switch
              [checked]="detection.active"
              onLabel="Active"
              offLabel="Muted"
              (valueChange)="onToggleChange(detection, $event)"
              [disabled]="updatingDetectionId() === detection.detectionId"
            ></kendo-switch>
          </kendo-card-footer>
        </kendo-card>
      </div>
      }
    </div>
  </div>
  }
</div>

@if (isLoading()) {
<div class="loading-overlay">
  <kendo-loader
    [type]="'infinite-spinner'"
    [size]="'large'"
  ></kendo-loader>
</div>
}
